import React from 'react';
import { ChevronLeft } from 'lucide-react';

const DashboardHeader = ({ onBackToHome, useCases, selectedUseCase, onUseCaseChange }) => {
  return (
    <div className="flex justify-between items-center px-4 py-2 bg-white rounded-lg shadow-sm mx-4">
      <div className="flex items-center">
        <button
          onClick={onBackToHome}
          className="flex items-center gap-1.5 text-secondary hover:text-secondaryDark transition-colors py-1.5 px-3 rounded-md hover:bg-gray-100"
        >
          <ChevronLeft size={18} />
        </button>
        {/* Uncomment if you want to enable use case selection
        <select
          className="py-1.5 px-3 border border-gray-200 rounded-md bg-gray-50 text-sm text-gray-700 cursor-pointer transition-all min-w-[180px] focus:outline-none focus:border-secondary focus:ring-2 focus:ring-secondary/20"
          onChange={onUseCaseChange}
          value={selectedUseCase}
        >
          {useCases.map(useCase => (
            <option key={useCase.id} value={useCase.id}>
              {useCase.name}
            </option>
          ))}
        </select>
        */}
      </div>
      <div className="flex items-center">
        <img src="/capgemini-logo.png" alt="Capgemini Logo" className="h-6 w-auto object-contain" />
      </div>
    </div>
  );
};

export default DashboardHeader;